module.exports = __webpack_public_path__ + "static/media/2 (50).0740a4ce.jpg";